module.exports = __webpack_public_path__ + "static/media/e.8c65f72e.svg";